<ion-app>
  <ng-container *ngIf="!splashScreen; else splash">
    <div class="appBgHeader" [ngClass]="headSize"></div>
    <ion-router-outlet> </ion-router-outlet>
    <div class="bottomTab" [ngClass]="getBarClass('tab')">
      <app-slide-bar class="rowRight"
        (positionChange)="onSlide($event)"
        [currentActiveRoute]="currentActiveRoute"
      ></app-slide-bar>
    </div>
  </ng-container>
  <!-- <ng-template #splash>
    <div class="noContentMenu">
      <div class="noInnerContent">
        <div class="loader bigLoad"></div>
      </div>
    </div>
  </ng-template> -->

    <ng-template #splash>
    <div class="noContentMenu">
      <div class="noInnerContent">
        <div class="loaderSplash">
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
</div>
        <!-- <img src="assets/splashh.gif" class="splashGif" /> -->
      </div>
    </div>
  </ng-template>
</ion-app>
